import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {
  InstantSearch, connectStateResults, ToggleRefinement
} from 'react-instantsearch-dom';

import ProductCardCarousel from '../product-card-carousel';

import searchClient from '../../utils/algolia';

const HiddenToggleRefinement = styled(ToggleRefinement)`
  display: none !important;
`;

const Separator = styled.hr`
  background: ${(props) => props.theme.color.brand};
  border: none;
  margin: 3rem 0;
  width: 100%;
  height: 1px;
`;

const AlgoliaProductCardCarousel = connectStateResults((props) => {
  const hasResults = props.searchResults && props.searchResults.nbHits !== 0;
  const results = props.searchResults ? props.searchResults.hits : [];

  const filteredResults = results.filter((hit) => (
    (Number(hit.objectID) !== props.productID) && (hit.title !== props.productName)));

  if (!hasResults) return null;

  return (
    <>
      <ProductCardCarousel
        taxonProducts={false}
        title={props.title}
        products={filteredResults}
        id={props.id}
        trackFor={props.trackFor}
        isInfinite
      />

      <Separator />
    </>
  );
});

const ProductCardCarouselWrapper = ({
  title,
  id,
  trackFor,
  productName,
  productID,
  productBreadcrumbs,
  brand
}) => {
  const isRelatedProducts = title === 'Related Products';

  const index = isRelatedProducts
    ? process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX
    : process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_FREQUENTLY_BOUGHT;

  const createValue = () => {
    if (productBreadcrumbs.length === 1) {
      return isRelatedProducts
        ? brand
        : productBreadcrumbs[0].name;
    }

    if (productBreadcrumbs.length >= 2) {
      return productBreadcrumbs.reduce((value, breadcrumb, i) => {
        if (i === 0) return breadcrumb.name;

        // if Also Bought With
        // then create a value that is 1 level
        // higher than the actual product
        if (!isRelatedProducts && i === productBreadcrumbs.length - 1) return value;
        return `${value} > ${breadcrumb.name}`;
      }, '');
    }

    return null;
  };

  const getAttribute = () => {
    if (productBreadcrumbs.length === 1) {
      return isRelatedProducts
        ? 'brand'
        : 'categories.lvl0';
    }

    if (productBreadcrumbs.length >= 2) {
      return `categories.lvl${productBreadcrumbs.length - (isRelatedProducts ? 1 : 2)}`;
    }

    return null;
  };

  const fallback = {
    attribute: getAttribute(),
    value: createValue()
  };

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={index}
    >
      <HiddenToggleRefinement
        // TODO: once Edits facet is backs
        // change this attributes to "Edits"
        // to populate Freq Bought Products
        attribute={fallback.attribute}
        value={fallback.value}
        label={''}
        defaultRefinement
      />

      <AlgoliaProductCardCarousel
        title={title}
        id={id}
        trackFor={trackFor}
        productID={productID}
        productName={productName}
      />
    </InstantSearch>
  );
};

ProductCardCarouselWrapper.defaultProps = {
  brand: '',
  title: '',
  id: '',
  trackFor: '',
  productName: '',
  productID: null,
  productBreadcrumbs: []
};

ProductCardCarouselWrapper.propTypes = {
  brand: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
  trackFor: PropTypes.string,
  productName: PropTypes.string,
  productID: PropTypes.number,
  productBreadcrumbs: PropTypes.array
};

export default ProductCardCarouselWrapper;
